<template>
  <div class="wrap">
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline blue darken-3">
          <span style="color:#fff;">Готово</span>
        </v-card-title>
        <v-card-text>
          Изменения успешно сохранены
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            Ок
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <Menu :menu="menu" @changeBlock="changeBlock" :item-index="blockIndex" />
    <v-toolbar flat color="blue darken-3" dark>
      <v-toolbar-title>Редактирование данных</v-toolbar-title>
    </v-toolbar>
    <template>
      <v-card v-if="Object.keys(editedItem.schema).length">
        <v-card-text>
          <v-card>
            <v-card-title class="headline">{{ editedItem.name }}</v-card-title>
            <v-card-subtitle>{{ editedItem.description }}</v-card-subtitle>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-card>
            <v-form ref="mainForm">
              <ManagementFields
                :forms="forms"
                :schema="editedItem.schema"
                :json="editedItem.json"
                :landing-id="getCurrentLandingId()"
              />
            </v-form>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed @click="cancel">Отмена</v-btn>
          <v-btn color="blue darken-3" dark @click="save">
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
      <div v-else class="pl-4 pt-4">
        Схема блока пуста
      </div>
    </template>
    <v-snackbar v-model="saveSnackBar" :multi-line="multiLine" color="primary">
      Изменения успешно сохранены
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="saveSnackBar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="snackbar" :multi-line="multiLine" color="red">
      {{ errorText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Menu from "@/components/Menu.vue";
import ManagementFields from "@/components/ManagementFields";
import errors from "@/mixins/errors";
import { API_URL_PREFIX, GLOBAL } from "@/config/consts";
import { mapGetters } from "vuex";

export default {
  name: "Management",
  data() {
    return {
      type: "blocks",
      items: [],
      forms: [],
      editedItem: {
        id: 0,
        name: "",
        schema: {},
        json: {}
      },
      overlay: false,
      dialog: false,
      multiLine: true,
      snackbar: false,
      saveSnackBar: false,
      errorText: "",
      baseLandingId: GLOBAL.baseLandingId,
      blockIndex: 0
    };
  },
  components: {
    ManagementFields,
    Menu
  },
  mixins: [errors],
  async created() {
    await this.initialize();
  },
  methods: {
    initialize() {
      this.getBlocks();
      this.getForms();
    },
    async getBlocks() {
      try {
        this.overlay = true;
        const { data } = await this.$axios.get(
          `${API_URL_PREFIX}/landings/${this.getCurrentLandingId()}/blocks/`
        );
        Object.values(data.list).map(item => {
          item.json = Array.isArray(item.json) ? {} : item.json;
        });
        this.items = data.list;
        if (this.items.length) {
          this.changeBlock(this.getIndex());
        }
      } catch ({ response }) {
        this.snackbar = true;
        this.errorText = this.getErrorText(response);
      } finally {
        this.overlay = false;
      }
    },
    async getForms() {
      try {
        const { data } = await this.$axios.get(
          `${API_URL_PREFIX}/landings/${this.getCurrentLandingId()}/forms/list`
        );
        this.forms = data.list;
      } catch ({ response }) {
        this.snackbar = true;
        this.errorText = this.getErrorText(response);
      }
    },
    changeBlock(index) {
      this.blockIndex = index;
      if (this.$refs.mainForm) {
        this.$refs.mainForm.resetValidation();
      }
      this.editedItem = this.items[this.blockIndex];
    },
    getIndex() {
      const index = this.$route.query.block_index;
      return index ? parseInt(index) : this.blockIndex;
    },
    getCurrentLandingId() {
      return this.$route.query.landing_id;
    },
    async save() {
      if (!this.$refs.mainForm.validate()) {
        return;
      }
      try {
        const blockId = this.editedItem.id;
        await this.$axios.patch(`${GLOBAL.apiUrl.blocks}${blockId}/json`, {
          json: this.editedItem.json
        });
        this.saveSnackBar = true;
      } catch ({ response }) {
        this.setErrors(response.data);
        this.snackbar = true;
        this.errorText = this.getErrorText(response);
      }
    },
    cancel: function() {
      this.$router.replace(
        {
          name: "Management",
          query: {
            block_index: this.blockIndex,
            landing_id: this.getCurrentLandingId()
          }
        },
        () => {
          this.$router.go(0);
        },
        () => {
          this.$router.go(0);
        }
      );
    }
  },
  computed: {
    ...mapGetters(["getErrorText"]),
    isBase() {
      return this.getCurrentLandingId() === this.baseLandingId;
    },
    menu() {
      return [
        { icon: "mdi-home", text: "На главную", link: "/" },
        {
          icon: "mdi-puzzle-plus",
          text: this.isBase ? "Базовые блоки" : "Конструктор блоков",
          link: `/blocks?landing_id=${this.getCurrentLandingId()}`
        },
        {
          icon: "mdi-text",
          text: this.isBase ? "Базовый менеджмент" : "Менеджмент",
          link: `/management?landing_id=${this.getCurrentLandingId()}`,
          model: true,
          children: this.items
        },
        {
          icon: "mdi-contacts",
          text: "Формы",
          link: `/forms?landing_id=${this.getCurrentLandingId()}`
        }
      ];
    }
  }
};
</script>
